import { Reveal } from "../lib/reveal";

const audience = [
  "Architects",
  "Town Planners",
  "Landscape Architects",
  "Urban Designers",
  "Builders & Drafters",
  "Environmental Consultants",
  "Surveyors & GIS Specialists",
];

export const Audience = () => (
  <section id="audience" data-testid="audience-section" className="px-5 md:px-10 max-w-[1400px] mx-auto py-24 md:py-32">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
      <div className="lg:col-span-5 lg:sticky lg:top-28">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-4">04 / Who we help</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-none">
            The people who shape place.
          </h2>
          <p className="text-muted-foreground mt-6 max-w-md leading-relaxed">
            We work across the disciplines that plan, design, measure and steward
            the built and natural environment — from studios of three to teams of
            three hundred.
          </p>
          <div className="mt-8 overflow-hidden aspect-video">
            <img
              src="https://images.unsplash.com/photo-1417716146732-918825b83fa0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHx1cmJhbiUyMHBsYW5uaW5nJTIwY2l0eSUyMGdyaWR8ZW58MHx8fHwxNzg0Mzc2ODcxfDA&ixlib=rb-4.1.0&q=85"
              alt="Urban city grid aerial"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 border-t border-border">
        {audience.map((a, i) => (
          <Reveal key={a} delay={i * 0.05}>
            <div
              data-testid={`audience-row-${i}`}
              className="group flex items-baseline justify-between gap-4 border-b border-border py-6 md:py-8 hover:px-4 transition-[padding] duration-300"
            >
              <span className="font-mono text-sm text-muted-foreground">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display font-bold text-3xl md:text-5xl tracking-tight flex-1 group-hover:text-primary transition-colors duration-300">
                {a}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
